import moment from 'moment';

export const uppercaseFirstLetter = (str: string): string => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const moneyFormat = (value: number): string => {
  return value.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD'
  });
};

export const getAirportCode = (airport: string): string => {
  const airportInfo = window.airports?.find((i) => i.icao === airport);
  return airportInfo?.code ?? airport;
};

export const minuteToFormat = (minute: number): string => {
  const hours = Math.floor(minute / 60);
  const minutes = minute % 60;
  return `${hours}h ${minutes}m`;
};

export const delayValue = (val: string) => {
  const value = parseInt(val);
  if (value < 0) return `-${value}m`;
  return `+${value}m`;
};

export const dateFormat = (date: string | Date, hour = true) => {
  if (!date) return '';
  if (!hour) return moment(date).format('DD/MM/YY');
  return moment(date).format('DD/MM/YY HH:mm');
};

export const formatNumber = (value: number) => {
  return value.toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  });
};

export const minutesToHHMM = (minutes: number) => {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return `${hours?.toString().padStart(2, '0')}:${mins
    ?.toString()
    .padStart(2, '0')}`;
};

export const noDataFallbackText = 'No data avail.';

export const noDataFallback = (str: string | undefined) => {
  if (
    !str ||
    str === '' ||
    str.toLowerCase().includes('no data') ||
    str === 'No data available'
  )
    return noDataFallbackText;
  return str;
};

export const stringFallback = (str: string | undefined, fallback: string) => {
  if (!str || str === '') return fallback;
  return str;
};

export const weatherWindArrowRotation = (val: string | undefined) => {
  if (typeof val === 'undefined') return 180;
  try {
    const value = parseInt(val, 10);
    return value + 180;
  } catch (e) {
    return 180;
  }
};

export const dateFormatUTC = (date: string | Date, hour = true) => {
  if (!date) return '';
  if (!hour) return moment.utc(date).format('DD/MM/YY');
  return moment.utc(date).format('DD/MM/YY HH:mm');
};

export const numberIsNotNegativeFallback = (str: string, fallback: string) => {
  if (!str || str === '') return fallback;
  const number = parseInt(str, 10);
  if (number < 0) return number * -1;
  return number;
};
